export const configureVoiceFlow = ({projectID, userName, GUID, locale}) => {
  return window.voiceflow.chat.load({
    verify: {projectID},
    url: 'https://general-runtime.voiceflow.com',
    versionID: 'production',
    assistant: {
      persistence: 'sessionStorage',
    },
    launch: {
      event: {
        type: 'launch',
        payload: {
          userName,
          GUID,
          locale,
        },
      },
    },
  });
};

export const addEventListeners = ({onOpen, onClose, showBubble}) => {
  if (__CLIENT__) {
    window.chat.open = async () => {
      await window.voiceflow.chat.open?.();
      window.voiceflow.chat.show?.();
    };
    window.chat.close = () => {
      window.voiceflow.chat.hide?.();
      window.voiceflow.chat.close?.();
    };
    window.addEventListener(
      'message',
      (event) => {
        if (event.data === '{"type":"voiceflow:open"}') {
          onOpen?.();
        }
        if (event.data === '{"type":"voiceflow:close"}') {
          onClose?.();
          if (!showBubble) {
            return window.voiceflow?.chat?.hide?.();
          }
        }
      },
      false
    );
  }
};

export const voiceFlowFunction = ({projectID, userName, GUID, locale, showBubble, onOpen, onClose, logger}) => {
  const v = document.createElement('script');
  const [s] = document.getElementsByTagName('script');
  try {
    v.onload = async () => {
      await configureVoiceFlow({projectID, userName, GUID, locale});
      if (!showBubble) {
        window.voiceflow.chat.hide?.();
      }
      addEventListeners({onOpen, onClose, showBubble});
    };
  } catch (error) {
    logger?.error(error.message);
  }

  v.src = 'https://cdn.voiceflow.com/widget-next/bundle.mjs';
  v.type = 'text/javascript';
  s.parentNode.insertBefore(v, s);
};
